module.exports = __webpack_public_path__ + "static/media/ppicon2.f90cc558.svg";